import jwt_decode from "jwt-decode";

interface TokenResponse {
  user_id: string 
}

const extactUserInfo = () : TokenResponse =>  {
  const token = localStorage.getItem("access_token")
  return jwt_decode(token) as TokenResponse
}


export default extactUserInfo